iScreenWizard.factory('Ontwikkelwijzerblok', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('ontwikkelwijzerblok', params).then(function (response) {
                var ontwikkelwijzerblokken = response.data;
                resolve(ontwikkelwijzerblokken);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('ontwikkelwijzerblok/'+id).then(function (response) {
                var ontwikkelwijzerblok = response.data;
                resolve(ontwikkelwijzerblok);
            }, reject);
        });
    };

    return data;
});